import React, { Component } from 'react';
import { connect } from 'react-redux';
import '../../assets/styles/components/instrument/manage-wathlist-group-mobile.scss'
import Edit from '@/assets/images/icons/mobiles/editwatchlist_icon_rename@2x.png';
import deleteIcon from '@/assets/images/icons/mobiles/editwatchlist_icon_deletegroup@2x.png'
import { WINVEST_PARAMS_JSON_FLAG } from '@/constants/win-vest'
import { userActions } from '@/actions/user';
import { SERVICES_RESP } from '@/configurations';
import { openMarketWatchListConfirmDialog ,openMarketAddGroupDialog } from '@/actions/app';
import LoadingLayer from '@/components/Spinner/LoadingLayer';
import { LOADING_TYPE } from '@/constants/app';

class ManageWatchlistGroup extends Component{
    constructor(props) {
        super(props)
        this.state={
            customTab:'',
            curretTanID:1,
            mainTabWidth:0,
            currentEdit:-1,
            currentGroupIndex: 0,
            currentEditItem:'',
            load:false
        }
    }

    render(){
        const { load , currentEdit } = this.state
        const { language , watchlist } = this.props
        return(
            <div className='manage-group-container'>
                
                <div className='manage-group-head'>
                    <span onClick={this.props.closeLayout}>X</span>
                    <span>{language.market_custom_watchlist_management}</span>
                </div>
                <div className='manage-group-content'>
                  <LoadingLayer type={LOADING_TYPE.BIG_IMG} load={load} />
                    {watchlist.custom && !load && watchlist.custom.map((item,index)=>{
                        return (
                            <div className='single-watchlist' key={index} >
                              {currentEdit == index ? <input className='single-watchlist-input' ref={e => this.inputEditRef = e} onClick={e => e.stopPropagation()}
                                autoFocus='autoFocus' onBlur={e => e.keyCode == 13 ? this.handleDocumentClick() : ''} ></input> :
                                <span className='single-watchlist-name' >{item.title}</span>}
                              <div className='single-watchlist-icon' >
                                <img src={Edit} className='swtachlist-icon-edit' onClick={(e) => this.handleEdit(e, item, index)} />
                                <img src={deleteIcon}  onClick={() => openMarketWatchListConfirmDialog(item, () => this.handleDelete(item), language.market_confirm_text ,'market_delete_confirm' )}></img>
                              </div>
                            </div>
                          )
                    })}
                </div>
                <div className='manage-group-btn' onClick = {openMarketAddGroupDialog}>
                    <span>{language.market_add_new_watchlist_group}</span>
                </div>
            </div>
        )
    }

    handleDocumentClick = () => {
        if (this.inputEditRef) {
          if (this.inputEditRef.value && this.inputEditRef.value != this.state.currentEditItem.title) {
            this.handleUpdateWatchlist()
          }
        }
        this.setState({ errorMessage: '', currentEdit: -1 })
      }

    handleUpdateWatchlist = () => {
        const newTitle = this.inputEditRef.value
        this.setState({ load: true })
        const { currentEditItem } = this.state
        const items = []
        if (currentEditItem.flaggings) {
            currentEditItem.flaggings.forEach(item => {
            items.push(item.id + ':' + item.market)
            });
        }
        const item = items.join(',');
        const params = {
            [WINVEST_PARAMS_JSON_FLAG.KEY]: WINVEST_PARAMS_JSON_FLAG.VALUE,
            return: 'Y',
            data: [
            {
                name: currentEditItem.name,
                title: newTitle,
                items: item,
            }
            ]
        }
        this.props.manageWatchList(params, res => {
            this.handleResponse(res,'',false,true)
        })

    }

    handleEdit(e, item, index) {
        e.stopPropagation()
        this.setState({ currentEdit: index, currentEditItem: item }, () => {
            this.inputEditRef.value = item.title
        })
    }

    handleResponse = (res, message, addLikeWatchlist = false,updataWatch = false) => {
        let timeout = setTimeout(() => {
          this.setState({ errorMessage:'', load: false, isLoadingConfirm: false})
        }, 10000);
        if (res.status === SERVICES_RESP.STATUS_OK) {
          const { userInfo } = this.props
        //   this.angInputRef.value = ''
          this.props.getWatchlist({ uuid: userInfo.id }, response => {
            clearTimeout(timeout)
            this.setState({ errorMessage:'', load: false, isLoadingConfirm: false})
            // if (addLikeWatchlist) {
            //   let currentGroup = response.result.filter(item => item.name == res.result[0].name)[0]
            //   let sortFlaggings =  currentGroup.flaggings.sort((a,b)=> { return b.weight - a.weight })
            //   currentGroup.flaggings = sortFlaggings
            //   this.setState({ currentGroup },()=>{
            //   })
            // }
            // if(this.props.subTabValue == this.state.currentGroup.name){
            //   this.props.handleRefreshTable()
            // }
            // if(updataWatch){  this.props.handleRefreshTable(true)}
            this.setState({ load: false, isLoadingConfirm: false, showInput: false })
          })
        } else {
          const errorMessage = res?.result ?? ''
          this.setState({ errorMessage, load: false, isLoadingConfirm: false })
        }
      }

      handleDelete(item, index) {
        // const position = {
        //   id:'1',
        //   isActive:false,
        //   title:"common_position",
        //   value:"position"
        // }
        // if(item.name === this.props.subTabValue){
        //   this.props.handleChangeSubTab(position,{id:'1'})
        // }
        // if(item.name === this.state.currentGroup.name){
        //   this.setState({currentGroup:{flaggings:[]}})
        // }
        this.setState({ load: true })
        const params = {
          name: item.name,
          template: 'watchlist2'
        }
        this.props.deleteWatchlist(params, res => this.handleResponse(res,'',false,true))
      }


    handleChangeWatchlistTab(activetab){
        
    }

    componentDidMount(){
        document.getElementsByClassName('drawer-layout')[0].addEventListener('click', this.handleDocumentClick)
    }

    componentWillUnmount() {
        document.getElementsByClassName('drawer-layout')[0].removeEventListener('click', this.handleDocumentClick)
      }
}








export default connect(
    state => ({
      language: state.app.language,
      watchlist: state.user.watchlist,
      userInfo: state.user.userInfo,
      markets: state.trade.markets,
      theme: state.app.theme,
    }),
    dispatch => ({
        manageWatchList: (p, c) => dispatch(userActions.manageWatchlistAction(p, c)),
        getWatchlist: (p, c) => dispatch(userActions.getInstrumentWatchlistAction(p, c)),
        deleteWatchlist: (p, c) => dispatch(userActions.deleteWatchlistAction(p, c)),
    }))(ManageWatchlistGroup)